<template>
  <div class="detail-layout">
    <div v-if="!inxbbQuickView" class="detail-layout-top">
      <div class="detail-layout-top__left">
        <i class="back-btn icon-arrow-left-s-line t-iconfont" @click="handleClick"></i>
        <div class="detail-layout-top__title">{{ title }}</div>
      </div>
      <div v-if="$slots.detailLayoutTopRight" class="detail-layout-top__right">
        <slot name="detailLayoutTopRight"></slot>
      </div>
    </div>
    <div
      class="detail-layout-box"
      :class="{ 'detail-layout-box--is-inxbb-quick-view': inxbbQuickView }"
    >
      <slot name="detailLayoutBox"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()

const route = useRoute()

defineProps({
  inxbbQuickView: {
    type: Boolean,
    default: false
  }
})

// 计算属性：判断当前路由是否需要缓存
const title = computed(() => {
  return route.meta.title
})

const handleClick = () => {
  router.back()
}
</script>

<style lang="scss" scoped>
.detail-layout {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail-layout-top {
    flex: 0 0 44px;
    position: relative;
    padding: 12px 8px;
    display: flex;
    align-items: center;
    .detail-layout-top__left {
      flex: 1;
      display: flex;
      align-items: center;

      .back-btn {
        flex: 0 0 auto;
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        background: #ffffff;

        box-sizing: border-box;
        border: 1px solid #f2f3f5;
        margin-right: 16px;

        /* 三级投影/高 */
        box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
      }
      .detail-layout-top__title {
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: #323233;
      }
    }
    .detail-layout-top__right {
      flex: 0 0 auto;
    }
  }
  .detail-layout-box {
    flex: 1;
    overflow: hidden;
    background: #f2f3f5;
  }
  .detail-layout-box--is-inxbb-quick-view {
    background: unset;
  }
}
</style>
